import { supabase } from "@/lib/supabaseClient";
import type { Subscription } from "@/types/models";

/** 활성 구독 조회 */
export async function getActiveSubscription(userId: string): Promise<Subscription | null> {
  const { data, error } = await supabase
    .from("subscriptions")
    .select("*")
    .eq("user_id", userId)
    .eq("is_active", true)
    .maybeSingle();

  if (error) {
    throw error;
  }
  return data;
}

/** 플러스 여부 확인 */
export async function isPlus(userId: string): Promise<boolean> {
  const subscription = await getActiveSubscription(userId);
  return subscription?.plan === "plus";
}
